export default "__VITE_ASSET__BVX8UXY0__"